var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourcesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.001,
    height: 77.001,
    viewBox: "0 0 77.001 77.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sourcesIcon",
    d: "M13752-10476h-70a3,3,0,0,1-3-3v-70a3,3,0,0,1,3-3h70a3,3,0,0,1,3,3v70A3,3,0,0,1,13752-10476Zm-54-22.249a2.5,2.5,0,0,0-2.5,2.5,2.5,2.5,0,0,0,2.5,2.5h40a2.5,2.5,0,0,0,2.5-2.5,2.5,2.5,0,0,0-2.5-2.5Zm0-9a2.5,2.5,0,0,0-2.5,2.5,2.5,2.5,0,0,0,2.5,2.5h40a2.5,2.5,0,0,0,2.5-2.5,2.5,2.5,0,0,0-2.5-2.5Zm0-27a2.5,2.5,0,0,0-2.5,2.5v18a2.5,2.5,0,0,0,2.5,2.5h40a2.5,2.5,0,0,0,2.5-2.5v-18a2.5,2.5,0,0,0-2.5-2.5Z",
    transform: "translate(-13678.5 10552.502)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcesIcon);
export default __webpack_public_path__ + "static/media/sourcesIcon.9da0cffeeea6936328829380f79f27c4.svg";
export { ForwardRef as ReactComponent };